// The colours of a number in Elements/MetricTiles: plain, green (a count that is as it should be), or amber.
const MetricTileToneEnum = {
  Plain: '',
  Good: 'good',
  Warn: 'warn',
};

export default MetricTileToneEnum;
